export default __webpack_public_path__ + "static/3-game-questions-544ec6ee4c135929afaf9ca1ca9c37d6.jpg";